export default __webpack_public_path__ + "static/media/Muli-ExtraBold.179c27d8.ttf";